import { Component, OnInit } from '@angular/core';

import { LessonStatus } from '@df/interfaces';

@Component({
    selector: 'app-teach-all-list',
    templateUrl: './teach-all-list.component.html',
    styleUrls: ['./teach-all-list.component.scss']
})
export class TeachAllListComponent implements OnInit {
    lesson_statuses = LessonStatus;

    constructor() {}

    public ngOnInit(): void {}
}
